import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import isNil from "lodash/isNil";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { CreateRuleLevelDialog } from "components/rules-management/RuleLevelDialog/CreateRuleLevelDialog";
import { useGetRule } from "hooks/rules/useGetRule";
import ProgressIndicatorContainer from "components/ProgressIndicatorContainer";
import { NewThresholdTable } from "./NewThresholdTable";

export const RuleInfo = ({ ruleId }) => {
  const [ruleLevelDialogOpen, setRuleLevelDialogOpen] = useState(false);

  const { loading, error, rule, refetchRule } = useGetRule(ruleId);

  const handleCreateRuleLevelSuccess = () => {
    refetchRule();
    setRuleLevelDialogOpen(false);
  };

  return isNil(rule) ? (
    <Typography>No rule selected</Typography>
  ) : (
    <>
      <ProgressIndicatorContainer loading={loading} error={error}>
        <Typography variant="h4">{rule.rule_name}</Typography>
        <Typography>Tag: {rule.tag_name}</Typography>
        <Typography>Active: {rule.rule_enabled.toString()}</Typography>
        <ThresholdHeader>
          <Typography variant="h5">Thresholds</Typography>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setRuleLevelDialogOpen(true)}
          >
            Create new threshold
          </Button>
        </ThresholdHeader>
        <NewThresholdTable
          loading={loading}
          ruleLevelData={rule.rule_levels}
          ruleId={rule.rule_id}
          onEditRuleLevel={refetchRule}
        />
      </ProgressIndicatorContainer>
      <CreateRuleLevelDialog
        ruleId={ruleId}
        open={ruleLevelDialogOpen}
        onClose={() => setRuleLevelDialogOpen(false)}
        onSuccess={handleCreateRuleLevelSuccess}
      />
    </>
  );
};

RuleInfo.propTypes = {
  ruleId: PropTypes.number,
  onRuleAdded: PropTypes.func
};

const ThresholdHeader = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
